window.EmployeeNotesAPI = new function () {

    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration.getBaseAPI('EmployeeNotes'));

    self.getBrandNoteTypesSettings = function (brandId) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/note_types', 'GET')
            .then(function (res) {
                    if (res.data && res.data.data) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.updateBrandNoteTypesSettings = function (brandId, payLoad) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/note_types', 'POST', payLoad)
            .then(function (res) {
                    if (res.data && res.data.data) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };
};
